var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid grid-cols-4 gap-3"},_vm._l((_vm.recommends),function(item){return _c('InformationCard',{key:item.no,attrs:{"report":item,"is-video":item.type==2}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }